import React from "react";
import { Link } from "gatsby";
import { WithClassName } from "./footer";

type FooterMenuType = WithClassName & {
    title: string;
    className?: string;
    items: any;
};

const FooterMenu: React.FC<FooterMenuType> = ({
    className = "",
    title,
    items,
}) => {
    const isUrlExternal = (url: string) => {
        try {
            new URL(url);
            return true;
        } catch (_) {
            return false;
        }
    }

    return (
        <div className={`${className} pb-8 md:pt-0 border-b border-stroke-color border-opacity-20 md:border-none text-center md:text-left`}>
            <p className="text-base-16 text-light-gray uppercase mb-[10px] font-bold">
                {title}
            </p>
            <div className={`flex flex-col`}>
                {items.map((link: { url: string; ID: number | string; title: string }) => {
                    return isUrlExternal(link.url) ?
                        <a
                            key={link.ID}
                            className="footer-link w-fit mx-auto md:mx-0 leading-[1.62] text-small-14 text-footer-text-color"
                            href={link.url}
                        >
                            <div dangerouslySetInnerHTML={{ __html: link.title }}></div>
                        </a>
                        :
                        <Link
                            key={link.ID}
                            className="footer-link w-fit mx-auto md:mx-0 leading-[1.62] text-small-14 text-footer-text-color"
                            to={link.url}
                        >
                            <div dangerouslySetInnerHTML={{ __html: link.title }}></div>
                        </Link>
                })}
            </div>
        </div>
    );
};

export default FooterMenu;